"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This is a very simple component for rendering
 * raw HTML. It's useful in situations when you
 * might be loading variable markup from an outside 
 * source (ex: API, config file).
 *
 * You have to be careful when using this.
 * IT SHOULD NEVER BE USED WITH USER INPUT.
 *
 * Read more here:
 * - https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
 * - https://stackoverflow.com/questions/27934238/rendering-raw-html-with-reactjs
 * - https://github.com/facebook/react/issues/12014
 */

var RawHTML = function RawHTML(_ref) {
  var children = _ref.children;
  return _react2.default.createElement("span", {
    dangerouslySetInnerHTML: { __html: children } });
};

exports.default = RawHTML;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-raw-html/dist/index.js
// module id = 228
// module chunks = 168707334958949